/**
 * Defines how the composition of dividends is to be determined.
 * tag: 42259
 * @readonly
 * @enum {number} (int)
 */
export enum DividendComposition {
  EquityAmountReceiver = 0,
  CalculationAgent = 1,
}
